var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkaleBotWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9195 0L37.3109 17.3914C39.3483 19.4288 39.3483 22.7322 37.3109 24.7696L23.6086 38.4719C21.5712 40.5094 18.2678 40.5094 16.2304 38.4719L2.52807 24.7696C0.490642 22.7322 0.490644 19.4288 2.52807 17.3914L19.9195 0Z",
    fill: "#30B3D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2171 18.7694C17.2485 18.7382 17.2733 18.7011 17.2903 18.6602C17.3073 18.6194 17.316 18.5756 17.316 18.5313C17.316 18.4871 17.3073 18.4433 17.2903 18.4025C17.2733 18.3616 17.2485 18.3245 17.2171 18.2933L12.9682 14.0561L8.71939 18.293C8.65622 18.3561 8.62074 18.4417 8.62074 18.5309C8.62074 18.6201 8.65622 18.7057 8.71939 18.7688L9.94211 19.9881L12.9682 16.9708L15.9944 19.989L17.2171 18.7694Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1295 18.7694C31.1609 18.7382 31.1858 18.7011 31.2027 18.6602C31.2197 18.6194 31.2284 18.5756 31.2284 18.5313C31.2284 18.4871 31.2197 18.4433 31.2027 18.4025C31.1858 18.3616 31.1609 18.3245 31.1295 18.2933L26.8807 14.0561L22.6318 18.293C22.5686 18.3561 22.5332 18.4417 22.5332 18.5309C22.5332 18.6201 22.5686 18.7057 22.6318 18.7688L23.8545 19.9881L26.8807 16.9708L29.9068 19.989L31.1295 18.7694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaleBotWhatsappIcon);
export default __webpack_public_path__ + "static/media/skaleBotWhatsappIcon.212789782c850e0fca9db4cb28c4efa8.svg";
export { ForwardRef as ReactComponent };